import React from 'react';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Icon from '@mui/material/Icon';
import Flight from '@mui/icons-material/Flight';
import Train from '@mui/icons-material/Train';
import LocationOn from '@mui/icons-material/LocationOn';
import Check from '@mui/icons-material/Check';
import ArrowRighth from '@mui/icons-material/ArrowForward';
import img from '../img/image.png'
import Container from '@mui/material/Container';
import { useState, useEffect } from 'react';
import { fetchFirstLevelSort, fetchProduct } from '../strapi';
import { useNavigate } from 'react-router-dom';
import Documentation from './Documentation';

function Products({ locale, content, contentD }) {
    const API_URL = process.env.REACT_APP_STRAPI_URL ;
    const navigate = useNavigate();
    const [products, setProducts] = useState([]);
    let catalog = [{ icon: <Flight sx={{ color: '#2D5B96', fontSize: 60, transform: 'rotate(90deg)' }} />, name: 'Flight'  },
    { icon: <LocationOn sx={{ color: '#2D5B96', fontSize: 60 }} />, name: 'LocationOn' },
    { icon: <Train sx={{ color: '#2D5B96', fontSize: 60 }} />, name: 'Train' }
    ]
    const [value, setValue] = useState(-1);
    const [firstLevel, setFirstLevel] = useState([]);
    const [list, setList] = useState([]);
    const [img, setImg] = useState(content?.images ? API_URL + content.images[value]?.url : img);
    function getList(name) {
        if (!products || !Array.isArray(products)) {
            setList([]);
            return;
        }
        const arr = products
            .filter(item => item.first_level_sort.title === name)
            .slice(0, 3);
        setList(arr);
        //console.log(arr);
    }

    const handleChange = (newValue) => {
        setValue(newValue);
        if (firstLevel && firstLevel[newValue]?.title) {
            getList(firstLevel[newValue].title);
        } else {
            setList([]);
        }
    };

    useEffect(() => {
        fetchProduct(locale)
        .then(data => {
            setProducts(data.data);
            handleChange(-1)
            //console.log('products:' + data.data)
        })
        .catch(err => {
        });
        fetchFirstLevelSort(locale)
            .then(data => {
                //console.log('firstLevel')
                setFirstLevel(data)
            })
            .catch(err => {
                //console.log('firstLevel: ' + { err })
            });

        
    }, [locale]);

    let more = locale === 'ru' ? 'Смотреть все' : 'View more';

    return (
        <div >
            <Container>
                <Typography gutterBottom variant="h4" component="div" className='block_title'>
                    {content?.title || ''}
                </Typography>
                
                <Grid container spacing={3} >
                    {firstLevel && firstLevel.length > 0 && firstLevel.map((item, index) =>
                        <Grid key={index} size={{ xs: 12, md: 4 }} sx={{ color: value !== index ? '' : 'white', height: '100%' }} className="btn btn-border-reveal">
                            <Box className={value === -1 && index === 0 && 'pulsate-anim'} sx={{ borderRadius: '20px', height: '100%', border: value === index ? '' : '#021526 1px solid', p: 3, bgcolor: (value !== index) ? '' : '#2D5B96' }} onClick={()=> navigate(`/products/${item.documentId}`)}>
                                <Box sx={{ bgcolor: '#E6F5FC', width: '60px', height: '60px', borderRadius: '45px', alignItems: 'center', p: 2 }}>
                                    {catalog.find(cat => cat.name === item.iconName)?.icon}
                                </Box>
                                <Typography sx={{ fontSize: '20px', fontWeight: 'bold', mt: 2 }} component="div">
                                    {item?.title || ''}
                                </Typography>
                                <Typography sx={{ fontSize: '16px' }} component="div">
                                    {item?.shortText || ''}
                                </Typography>
                            </Box>
                        </Grid>
                    )}
                </Grid>
                <Documentation content={contentD} locale={locale} />
                {/* {value != -1 &&
                <Grid container spacing={2} sx={{ mt: '100px' }}>
                <Grid size={{ xs: 12, md: 6 }} ><img alt='img' className='mainPageImg' src={content?.images ? API_URL + content.images[value].url : img}></img></Grid>
                <Grid size={{ xs: 12, md: 6 }}>
                    <Typography sx={{ fontSize: '48px', lineHeight: '62px', fontWeight: 'bold', mt: 2 }} component="div">
                        {firstLevel && firstLevel[value]?.title || ''}
                    </Typography>
                    {
                        list && list.length > 0 && list.map((item, index) => 
                            <Typography className='mainText' key={index} sx={{ fontSize: '16px', lineHeight: '20px', mt: 1, verticalAlign: 'center' }} component="div">
                                <Check sx={{ mr: 1 }} /><a style={{color: '#2D5B96'}} href={`/products/${item?.documentId}` || ''}>{item?.name || ''}</a>
                            </Typography>
                        )
                    }
                    <br mt='100px'></br>
                    <a className='href' href='/products/0'>{more} <ArrowRighth sx={{ ml: 1 }} ></ArrowRighth></a>
                </Grid>
            </Grid>
                } */}
                
            </Container>
        </div>
    );
}
export default Products;
